import { createFileRoute } from '@tanstack/react-router'

import {
  listSearchValidator,
  useListFilters,
} from '@/components/Internal/DataTable'
import { MasterDetailLayout } from '@/components/Internal/MasterDetailLayout'
import { useUserActions } from '@/components/Internal/Users/use-user-actions'
import { userListFilters } from '@/components/Internal/Users/user-list-filters'
import { UserDetail } from '@/components/Internal/Users/UserDetail'
import { UsersTable } from '@/components/Internal/Users/UsersTable'

export const Route = createFileRoute('/internal/system/administration/users')({
  validateSearch: listSearchValidator(userListFilters),
  component: UsersScreen,
})

/**
 * The accounts, and the one beside them.
 *
 * The acts an account allows are held here rather than in the list: the pane
 * offers the same ones, and built twice they would be two sets of dialogs over
 * one screen.
 */
function UsersScreen() {
  const filters = useListFilters(userListFilters, Route)
  const selected = filters.values.selected
  const { actionsFor, create, edit, dialogs } = useUserActions()

  return (
    <>
      <MasterDetailLayout
        storageKey="split:users"
        sidebar={
          selected != null ? (
            <UserDetail
              userId={selected}
              actionsFor={actionsFor}
              onEdit={edit}
              onClose={() => filters.set('selected', null)}
            />
          ) : undefined
        }
      >
        <UsersTable
          filters={filters}
          actionsFor={actionsFor}
          onCreate={create}
        />
      </MasterDetailLayout>

      {dialogs}
    </>
  )
}
